let initCart = {
	expires: 0,
	submitting: false,
	message: '',
	data: []
}

const cart = (state = initCart, action) => {
	const exp = Math.floor(Date.now() / 1000) + 600; // current time + 10 min
	
	switch (action.type) {
		case 'USER_FAILURE':
		case 'MEMBER_FAILURE':
		case 'LOGIN_SUCCESS':
		case 'LOGOUT_SUCCESS':
			return initCart;
		case 'CART_FETCH_REQUEST':
		case 'CART_ADD_REQUEST':
		case 'CART_DELETE_REQUEST':
		case 'CHECKOUT_REQUEST':
			return {...state, submitting: true, message: ''}
		case 'CART_FETCH_SUCCESS':
		case 'CART_ADD_SUCCESS':
		case 'CART_DELETE_SUCCESS':
			return {...state, submitting: false, expires: exp, data: action.response, message: ''}
		case 'CHECKOUT_SUCCESS':
			return {...state, submitting: false, expires: exp, data: [], message: ''}
		case 'CART_FETCH_FAILURE':
			return {...state, submitting: false, expires: 0, data: [], message: action.error}
		case 'CART_ADD_FAILURE':
		case 'CART_DELETE_FAILURE':
		case 'CHECKOUT_FAILURE':
			return {...state, submitting: false, message: action.error}
		case 'RESET_ERROR_MESSAGE':
			return {...state, message: ''}
		default:
			return state;
	}
}

export default cart